module.exports = __webpack_public_path__ + "static/media/Nibss-Logo.e800c5ef.png";